var RESPONSE = {
    "status": {
        "code": 417,
        "message": "Unable to save data on core bank service, please resolve validation errors",
        "description": ""
    },
    "data": {
        "Errors": [
            "Client : Client Risk Indicator Date already exist  2/8/2019: Date of Hiering in Previous job",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Date of resign from Previous  job",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Nature of current job ",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: No of years in current service or business",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Previous job",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: No of years in previous job",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Date of Hiering in Current job",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Monthly salary",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Monthly loan payments borrower",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Monthly loan payments guarantor",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Loan Details",
            "Client :  Client Risk Indicator Date already exist  2/8/2019:  Personal expenses",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Other income",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Net Income",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Debt Burden as borrower",
            "Client :  Client Risk Indicator Date already exist  2/8/2019:  Debt Burden as borrower and guarantor",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Instalments to total Net income ratio",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Debt Burden (Exsiting Loans) Ratio",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Number of employees - full time",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Number of employees - part time",
            "Client :  Client Risk Indicator Date already exist  2/8/2019: Number of Jobs Created",
            "Gurantor_1 : Duplicate Client",
            "Loan : Loan has negative or null reference client id  -2. (New client might not have been saved!)",
            "Loan :  Loan has negative or null reference client id  -2. (New client might not have been saved!)",
            "Loan :  Loan has negative or null reference client id  -2. (New client might not have been saved!)",
            "Loan : Requested amount must be lower than or equal to10000"
        ],
        "model": {
            "TenantId": 245,
            "CompanyBranchId": 15,
            "LoanProductId": 18,
            "LoanApplicationId": 4009,
            "ClientReferenceNumber": null,
            "LoanApplicationDate": "2019-02-08T10:48:44.457",
            "RequestedLoanAmount": 5000000,
            "ApprovedLoanAmount": 2500,
            "TotalRecieiveableAmount": null,
            "LoanDisbursementDate": null,
            "LoanMaturityDate": null,
            "TotalInstallments": 36,
            "InstallmentAmount": 77,
            "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
            "GeofenceId": null,
            "CurrencyId": null,
            "InsurancePremiumAmount": null,
            "AssetInsurancePremiumAmount": null,
            "ApplicationStatusLkp": 32857,
            "CreatedBy": "whajahja@vitasjordan.com ",
            "CreatedDate": "2019-01-27T07:25:14.363",
            "LastUpdatedBy": "ahussein@vitasjordan.com",
            "LastUpdatedDate": "2019-02-08T11:09:28.867",
            "LoanApplicationNumber": "1200000004",
            "TotalTenure": null,
            "Creator": null,
            "OtherLoanInstituteName": null,
            "OtherLoanTotalAmount": null,
            "OtherLoanUsage": null,
            "ServiceCharges": null,
            "DocumentationFee": null,
            "ProcessInstanceID": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
            "LoanCycle": null,
            "AccumulativePovertyScore": null,
            "AccumulatedCreditScore": null,
            "TypeOfScreeningLkp": null,
            "LoanType": null,
            "UtilizationComments": null,
            "ChannelReferenceId": null,
            "AppVersionNumber": null,
            "OtherLoanOutstandingAmount": null,
            "TotalLoanUtilization": null,
            "PreviousLoanAmount": null,
            "OtherLoanCompletionDate": null,
            "PreviousPscScore": null,
            "TrainingFee": null,
            "LoanPurpose": "احتياجات طبيه",
            "WorkflowState": null,
            "ExecutorId": "0559a72c-8eee-4321-8646-c83853d67225",
            "IsDBRUpdated": false,
            "TmxBusinessLoanApplicationDetail": [],
            "TmxCustomerMaster": [
                {
                    "CustomerMasterId": 6081,
                    "CustomerCode": "11492506",
                    "CustomerTitle": null,
                    "CustomerName": "مجاهد",
                    "CustomerTypeLkp": 8,
                    "CustomerClassificationLkp": null,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:25:14.377",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:48.587",
                    "TenantId": 1,
                    "LocationId": null,
                    "MultiSiteCustomerFlag": null,
                    "NationalIdTypeLkp": null,
                    "NationalIdentifierValue": "9721018881",
                    "CustomerStatusLkp": null,
                    "AccountApplicationId": null,
                    "LoanApplicationId": 4009,
                    "FATCAClassLkp": null,
                    "RelationshipCodeLkp": null,
                    "CustomerSegmentLkp": null,
                    "CustomerSubSegmentLkp": null,
                    "EntityTypeLkp": null,
                    "SameAsAboveLkp": null,
                    "ETBFlag": 1,
                    "NTIFlag": null,
                    "negcustomer": null,
                    "negarea": null,
                    "TmxAccountApplication": null,
                    "TmxCustomerCRSIFTR": [],
                    "TmxCustomerCRSIFTRAddressMapping": [],
                    "TmxCustomerBusinessDetail": null,
                    "TmxCustomerDetail": [
                        {
                            "CustomerDetailId": 2094,
                            "TaxFiler": null,
                            "NationalTaxNumber": null,
                            "CustomerRelationshipContract": null,
                            "ExistingAccountHolder": null,
                            "PriorityCustomer": null,
                            "LoyaltyPoints": null,
                            "EverDiscontinuedPriority": null,
                            "ReasonForDiscontinuityLkp": null,
                            "FrequencyOfContractingRMLkp": null,
                            "PreferredModeOfCommunicationLkp": null,
                            "RelationWithBanks": null,
                            "CustomerMasterId": 6081,
                            "SMSAlert": null,
                            "WebsiteAddress": null,
                            "CustomerProfile": null,
                            "HighRiskApproval": null,
                            "PoliticalFigureApprovedObtained": null,
                            "PoliticalFigureName": null,
                            "RelativePoliticalFigure": null,
                            "RiskLevel": null,
                            "SourcesOfFunds": null,
                            "ExpectedCitiesTxn": null,
                            "ExpectedCountriesTxn": null,
                            "ExpectedCounterParties": null,
                            "BranchComments": null,
                            "TenantId": 0,
                            "CreatedBy": "whajahja@vitasjordan.com ",
                            "CreatedDate": "2019-01-27T07:25:14.377",
                            "LastUpdatedBy": "ahussein@vitasjordan.com",
                            "LastUpdatedDate": "2019-02-08T10:48:48.427",
                            "CustomerTotalFamilyIncomeAmount": null,
                            "CustomerTotalFamilyExpenseAmount": null,
                            "CurrencyID": null,
                            "PersonId": 5902,
                            "CustomerTotalSelfIncomeAmount": null,
                            "CustomerTotalSelfExpenseAmount": null,
                            "ActiveFlag": false,
                            "EffectiveStartDate": "2019-02-08T10:48:46.883",
                            "EffectiveEndDate": "2019-02-08T10:48:46.883",
                            "TmxCurrency": null,
                            "TmxCustomerBusinessDetail": [],
                            "TmxCustomerProfile": [],
                            "TmxCustomerExpectedCityTransaction": [],
                            "TmxCustomerExpectedCounterParties": null,
                            "TmxCustomerExpectedCountryTransaction": [],
                            "TmxPerson": {
                                "PersonID": 5902,
                                "PersonFirstName": "مجاهد",
                                "PersonDateOfBirth": "1972-02-25T00:00:00",
                                "PersonGenderLkp": 40545,
                                "CreatedBy": "whajahja@vitasjordan.com ",
                                "CreatedDate": "2019-01-27T07:25:14.377",
                                "LastUpdatedBy": "ahussein@vitasjordan.com",
                                "LastUpdatedDate": "2019-02-08T10:48:55.613",
                                "TenantID": 0,
                                "PersonMiddleName": "عبد المهدى",
                                "PersonLastName": "العواجين",
                                "ActiveFlag": false,
                                "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                "PersonMaritalStatusLkp": 41375,
                                "PersonBirthName": null,
                                "PersonCallingName": null,
                                "PersonEducationLkp": 41396,
                                "PersonResidenceLkp": 45162,
                                "PersonResidenceDuration": null,
                                "PersonReligion": null,
                                "FamilyHeadFlag": null,
                                "PersonTechnicalVocationalTraining": null,
                                "PersonTechnicalVocationalTrainingTypeLkp": null,
                                "PersonDisabilityFlag": null,
                                "PersonDisabilityNature": null,
                                "FamilyEarningMemberFlag": null,
                                "PersonHealthLkp": null,
                                "PersonProfessionTypeLkp": null,
                                "PersonTotalIncomeAmount": null,
                                "PersonTotalExpenseAmount": null,
                                "PersonWeddingDate": null,
                                "PersonCurrentAddress": null,
                                "PersonPermanentAddress": null,
                                "CurrencyID": null,
                                "PersonFamilyIdentifier": null,
                                "FamilyChildrenCount": null,
                                "FamilyDependentCount": null,
                                "FamilyMembersCount": 0,
                                "FamilyMigrantsCount": null,
                                "FamilyEarningMembersCount": null,
                                "PersonNationalityLkp": 41378,
                                "PlaceOfBirthLkp": null,
                                "PersonHobbies": null,
                                "PersonLanguagePreferenceLkp": null,
                                "UDFData": "{\"ObjectState\":0,\"SpouseFirstName\":\"هبه\",\"OfficeTelephoneNumber1\":\"0795222475\"}",
                                "TmxCurrency": null,
                                "TmxCustomerDetail": null,
                                "TmxPersonProfessionDetail": [
                                    {
                                        "PersonProfessionDetailId": 6123,
                                        "ProfessionTypeLkp": 41521,
                                        "OthersProfessionType": null,
                                        "TitlePosition": null,
                                        "EmployedSince": null,
                                        "YearsofEngagement": 9,
                                        "NameOfEmployer": "مشرف",
                                        "SalaryPerAnum": null,
                                        "NameOfBusiness": null,
                                        "NatureOfBusiness": null,
                                        "DateOfIncorporation": "2010-01-27T00:00:00",
                                        "InvestmentInBusiness": null,
                                        "BusinessTurnOver": null,
                                        "StatusOfOwnership": null,
                                        "SalaryIncome": null,
                                        "SbpIndustryParentLkp": null,
                                        "SbpIndustryLkp": null,
                                        "StatusLkp": 41568,
                                        "CountryOfIncorporation": null,
                                        "ProfessionalDegreeForSEP": null,
                                        "DepartmentName": null,
                                        "EstablishedSince": null,
                                        "PreviousEmployerName": "محاسب",
                                        "PreviousEmployerYearsOfEngagement": 6,
                                        "OverallLengthOfService": null,
                                        "AddressId": null,
                                        "SegmentLkp": null,
                                        "OfficeTelephoneNumber1": null,
                                        "OfficeTelephoneExtension": null,
                                        "OfficeAddress": "الطفيله - البرنيس - وزاره الشباب - مشرف",
                                        "PersonId": 5902,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:25:14.393",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.78",
                                        "TenantId": 0,
                                        "TmxAddress": null,
                                        "TmxTenant": null
                                    }
                                ],
                                "TmxPersonToAddressMapping": [],
                                "TmxPersonNationalIdentifier": [
                                    {
                                        "TenantId": 0,
                                        "PersonNationalIdentifierId": 12642,
                                        "NationalIdTypeLkp": 6,
                                        "NationalIdentifierValue": "061/083",
                                        "NationalIdIssueDate": null,
                                        "NationalIdExpiryDate": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:25:14.377",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.33",
                                        "PersonId": 5902,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "DocumentType": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "TenantId": 0,
                                        "PersonNationalIdentifierId": 12643,
                                        "NationalIdTypeLkp": 5,
                                        "NationalIdentifierValue": "9721018881",
                                        "NationalIdIssueDate": null,
                                        "NationalIdExpiryDate": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:25:14.377",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.48",
                                        "PersonId": 5902,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "DocumentType": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "TenantId": 0,
                                        "PersonNationalIdentifierId": 12644,
                                        "NationalIdTypeLkp": 2,
                                        "NationalIdentifierValue": "kgc81196",
                                        "NationalIdIssueDate": null,
                                        "NationalIdExpiryDate": "2027-03-19T00:00:00",
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:25:14.393",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.63",
                                        "PersonId": 5902,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "DocumentType": 41721,
                                        "TmxTenant": null
                                    }
                                ],
                                "TmxPersonIncomeDetail": [
                                    {
                                        "PersonIncomeDetailId": 13593,
                                        "IncomeSourceLkp": 1,
                                        "MonthlyIncomeAmount": 600,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.523",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13594,
                                        "IncomeSourceLkp": 2,
                                        "MonthlyIncomeAmount": 580,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.677",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13595,
                                        "IncomeSourceLkp": 3,
                                        "MonthlyIncomeAmount": 610,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.83",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13596,
                                        "IncomeSourceLkp": 4,
                                        "MonthlyIncomeAmount": 600,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.98",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13597,
                                        "IncomeSourceLkp": 5,
                                        "MonthlyIncomeAmount": 596.67,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.13",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13598,
                                        "IncomeSourceLkp": 6,
                                        "MonthlyIncomeAmount": 150,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.277",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13599,
                                        "IncomeSourceLkp": 8,
                                        "MonthlyIncomeAmount": 358,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.437",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13600,
                                        "IncomeSourceLkp": 7,
                                        "MonthlyIncomeAmount": 160,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.59",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13601,
                                        "IncomeSourceLkp": 11,
                                        "MonthlyIncomeAmount": 200,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.737",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13602,
                                        "IncomeSourceLkp": 9,
                                        "MonthlyIncomeAmount": 50,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:57.887",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13603,
                                        "IncomeSourceLkp": 14,
                                        "MonthlyIncomeAmount": 230,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.037",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonIncomeDetailId": 13604,
                                        "IncomeSourceLkp": 15,
                                        "MonthlyIncomeAmount": 1748,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.62",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:58.183",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "SalaryIncomeModeLkp": null,
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    }
                                ],
                                "TmxPersonExpenseDetail": [
                                    {
                                        "PersonExpenseDetailId": 7104,
                                        "ExpenseSourceLkp": 3,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:55.767",
                                        "MonthlyExpenseAmount": 55,
                                        "ExpenseModeLkp": null,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonExpenseDetailId": 7105,
                                        "ExpenseSourceLkp": 1,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:55.917",
                                        "MonthlyExpenseAmount": 180,
                                        "ExpenseModeLkp": null,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonExpenseDetailId": 7106,
                                        "ExpenseSourceLkp": 2,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.073",
                                        "MonthlyExpenseAmount": 130,
                                        "ExpenseModeLkp": null,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonExpenseDetailId": 7107,
                                        "ExpenseSourceLkp": 4,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.223",
                                        "MonthlyExpenseAmount": 365,
                                        "ExpenseModeLkp": null,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    },
                                    {
                                        "PersonExpenseDetailId": 7108,
                                        "ExpenseSourceLkp": 5,
                                        "TenantId": 0,
                                        "CurrencyId": null,
                                        "CreatedBy": "whajahja@vitasjordan.com ",
                                        "CreatedDate": "2019-01-27T07:49:25.603",
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "LastUpdatedDate": "2019-02-08T10:48:56.377",
                                        "MonthlyExpenseAmount": 89,
                                        "ExpenseModeLkp": null,
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2099-03-12T00:00:00",
                                        "PersonId": 5902,
                                        "TmxCurrency": null,
                                        "TmxTenant": null
                                    }
                                ],
                                "TmxTenant": null,
                                "ObjectState": 0,
                                "SpouseFirstName": "هبه",
                                "OfficeTelephoneNumber1": "0795222475"
                            }
                        }
                    ],
                    "TmxCustomerIntroducer": [
                        {
                            "CustomerIntroducerId": 26427,
                            "IntroducerNumber": null,
                            "MaintianingAccountSince": null,
                            "Name": "سعيد محمد",
                            "CustomerRelationLkp": null,
                            "AccountNumber": null,
                            "BankName": null,
                            "BranchName": null,
                            "HomeAddressID": null,
                            "WorkAddressID": null,
                            "CustomerMasterId": 6081,
                            "CreatedBy": "ahussein@vitasjordan.com",
                            "CreatedDate": "2019-02-08T10:49:01.033",
                            "LastUpdatedBy": "ahussein@vitasjordan.com",
                            "LastUpdatedDate": "2019-02-08T10:49:01.033",
                            "TmxAddress": null,
                            "TmxAddress1": null,
                            "TmxCustomerMaster": null,
                            "TenantId": 0,
                            "TmxTenant": null,
                            "ObjectState": 0,
                            "HomeAddress": "عمان _ الجبيهه",
                            "HomePhoneNumber": "0774511122",
                            "WorkAddress": "جبل الحسين",
                            "WorkPhoneNumber": "0774136368"
                        }
                    ],
                    "TmxCustomerPreferenceRating": [],
                    "TmxCustomerOtherAccounts": [],
                    "TmxCreditRiskProfile": [],
                    "TmxAccountKin": [],
                    "TmxEntityContactPerson": [],
                    "TmxAccountGuardian": [],
                    "TmxCustomerFatcaDetail": [],
                    "TmxCustomerFinancialProfile": [],
                    "TmxCustomerBankingDetails": [],
                    "eCIBReportMaster": [],
                    "TmxCustomerPJP": [],
                    "TmxECIBDetail": [],
                    "TmxLocation": null,
                    "TmxPJPClusterCustomerMapping": [],
                    "TmxCustomerExistingLoan": [
                        {
                            "CustomerExistingLoanID": 5648,
                            "CustomerMasterId": 6081,
                            "LoanStatus": "Active",
                            "RejectionReason": null,
                            "ClientStatus": "Regular",
                            "CustomerStatus": null,
                            "OutstandingBalance": 1137.46,
                            "LastInstallmentDate": "2021-05-05T00:00:00",
                            "TotalInstallment": 30,
                            "PaidInstallment": 7,
                            "MonthlyInstallmentAmount": 52,
                            "FullyPaidDate": null,
                            "LatePaymentCount": 0,
                            "DelayInDays": 0,
                            "LoanProduct": "MDL(Small)",
                            "TmxCustomerMaster": null,
                            "ObjectState": 0,
                            "NationalId": 9721018881,
                            "FirstName": "مجاهد",
                            "FatherName": "عطا الله",
                            "GrandFatherName": "عبد المهدى",
                            "LastName": "العواجين",
                            "LastLoanAmount": 1200,
                            "PaidInstallmentCount": 2,
                            "CreatedDate": "2019-02-08T10:48:46.8830374Z",
                            "CreatedBy": "",
                            "LastUpdatedBy": "",
                            "LastUpdatedDate": "2019-02-08T10:48:46.8830374Z"
                        }
                    ],
                    "TmxTenant": null,
                    "FRMUStatus": null,
                    "SLSStatus": null,
                    "UDFData": "{\"LoanApplicationId\":4009,\"TmxCustomerPJP\":[],\"ObjectState\":0,\"ExistingCustomer\":\"8\",\"FatherFirstName\":\"عطا الله\",\"EnglishName\":\"Mujahed Ata Allah Abd Almahdi Alawajen\",\"MotherName\":\"عائشه\",\"Age\":46,\"Region\":\"42653\",\"City\":\"41978\",\"HomeAddress\":\"الطفيله - البرنيس - قرب مديريه الاراضي - ثالث منزل خلف المديريه مباشره\",\"RelationWithVitasEmployee\":\"8\",\"RelationWithVitasStaff\":\"ابن عم\",\"LoanProduct\":\"41674\",\"LoanType\":\"42724\",\"ClientEconomicSector\":\"41406\",\"ClientActivities\":\"41471\",\"HowDidYouKnowUs\":\"41097\",\"Collateral1\":\"8\",\"Collateral2\":\"8\",\"Collateral3\":\"8\",\"Collateral4\":\"8\",\"Collateral5\":\"8\",\"Collateral6\":\"8\",\"Collateral7\":\"8\",\"Collateral8\":\"8\",\"ClientSalaryToBank\":\"41274\",\"SpouseSalaryToBank\":\"41280\",\"ChildernSalaryToBank\":\"41296\",\"OtherIncomeSource\":[{\"IncomeResourcesName\":\"سائق\",\"MonthlyIncomeAmount\":230,\"SalaryIncomeModeLkp\":\"32874\",\"OtherIncomeSourceId\":null}],\"TmxExistingLoansOtherInstitutes\":[{\"PreLoanBranchName\":41289,\"PreLoanOutstandingBalance\":1400,\"MonthlyInstallment\":55,\"PreLoanMaturityDate\":\"2020-01-27T03:00:00\",\"ExistingLoansOtherInstitutesId\":null}],\"ComplianceLoanProdRecomm\":\"45030\",\"EcibFetchFlag\":0}",
                    "ObjectState": 0,
                    "ExistingCustomer": "8",
                    "FatherFirstName": "عطا الله",
                    "EnglishName": "Mujahed Ata Allah Abd Almahdi Alawajen",
                    "MotherName": "عائشه",
                    "Age": 46,
                    "Region": "42653",
                    "City": "41978",
                    "HomeAddress": "الطفيله - البرنيس - قرب مديريه الاراضي - ثالث منزل خلف المديريه مباشره",
                    "RelationWithVitasEmployee": "8",
                    "RelationWithVitasStaff": "ابن عم",
                    "LoanProduct": "41674",
                    "LoanType": "42724",
                    "ClientEconomicSector": "41406",
                    "ClientActivities": "41471",
                    "HowDidYouKnowUs": "41097",
                    "Collateral1": "8",
                    "Collateral2": "8",
                    "Collateral3": "8",
                    "Collateral4": "8",
                    "Collateral5": "8",
                    "Collateral6": "8",
                    "Collateral7": "8",
                    "Collateral8": "8",
                    "ClientSalaryToBank": "41274",
                    "SpouseSalaryToBank": "41280",
                    "ChildernSalaryToBank": "41296",
                    "OtherIncomeSource": [
                        {
                            "IncomeResourcesName": "سائق",
                            "MonthlyIncomeAmount": 230,
                            "SalaryIncomeModeLkp": "32874",
                            "OtherIncomeSourceId": null
                        }
                    ],
                    "TmxExistingLoansOtherInstitutes": [
                        {
                            "PreLoanBranchName": 41289,
                            "PreLoanOutstandingBalance": 1400,
                            "MonthlyInstallment": 55,
                            "PreLoanMaturityDate": "2020-01-27T03:00:00",
                            "ExistingLoansOtherInstitutesId": null
                        }
                    ],
                    "ComplianceLoanProdRecomm": "45030",
                    "EcibFetchFlag": 0
                }
            ],
            "TmxGeofence": null,
            "TmxLoanApplicationPurchaseAsset": [],
            "TmxLoanApplicationPSCValuation": [
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16354,
                    "PSCValue": 68,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 11,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.897",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16355,
                    "PSCValue": 45112,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 12,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.053",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16356,
                    "PSCValue": 45118,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 13,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.2",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16357,
                    "PSCValue": 45120,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 3,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.35",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16358,
                    "PSCValue": 45123,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 4,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.503",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16359,
                    "PSCValue": 45126,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 5,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.65",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16360,
                    "PSCValue": 45129,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 6,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.8",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16361,
                    "PSCValue": 45131,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 7,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:53.95",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16362,
                    "PSCValue": 45133,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 8,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.1",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16363,
                    "PSCValue": 45140,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 9,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.253",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationId": 4009,
                    "PSCQuestionResponseId": null,
                    "LoanApplicationPSCValuationId": 16364,
                    "PSCValue": 45142,
                    "TenantId": 0,
                    "TmxLoanApplication": null,
                    "TmxPSCQuestionResponse": null,
                    "PSCQuestionMasterId": 10,
                    "Status": null,
                    "Error": null,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.41",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxPSCQuestionsMaster": null,
                    "TmxTenant": null
                }
            ],
            "TmxProduct": {
                "TenantId": 1,
                "TenantFeildString": null,
                "ProductId": 18,
                "ProductCode": "6020",
                "ProductName": "Personal Loan",
                "ProductDescription": "Vitas Jordan Personal Loan",
                "ProductTypeLkp": 6,
                "ProductTenureMonths": 12,
                "CreatedBy": "Zoaib",
                "CreatedDate": "2017-03-03T00:00:00",
                "LastUpdatedBy": "rashid.liaqat@techlogix.com",
                "EffectiveStartDate": "2017-02-03T00:00:00",
                "EffectiveEndDate": "2028-02-03T00:00:00",
                "LastUpdatedDate": "2018-07-26T14:00:54.43",
                "RepaymentModeLkp": null,
                "RepaymentFrequencyLkp": null,
                "DocumentationFee": null,
                "ServiceFee": null,
                "ProcessingFee": null,
                "CurrencyId": 1,
                "IsGroup": null,
                "IsIndividual": null,
                "WorkflowSchemeCode": "LoanApplicationWF",
                "TmXProductCycle": [],
                "TmxLoanProductChecklist": null,
                "TmxPSCQuestionsMaster": [],
                "TmxCreditScoreQuestion": [],
                "TmXBranchProductsMapping": [],
                "TenantFieldString": null,
                "TmxCurrency": null,
                "TmxLoanApplication": null,
                "TmxProductCycle": null,
                "GroupFlag": false,
                "IndividualFlag": true,
                "ActiveFlag": true,
                "TmxAccountApplication": null,
                "TmxProductRule": null,
                "TmxProductChecklist": null,
                "TmxTenant": null
            },
            "TmxUser": {
                "UserName": "whajahja@vitasjordan.com",
                "FirstName": "Wafeeqa",
                "MiddleName": null,
                "LastName": "Hajahja",
                "CompanyId": null,
                "DesignationLkpID": 2,
                "EmailAddress": "whajahja@vitasjordan.com",
                "RoleName": null,
                "UserTypeLkpID": null,
                "ContactNumber": "0778405547",
                "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
                "CreatedBy": "dborini@vitasjordan.com",
                "CreatedDate": "2018-11-22T10:06:01.997",
                "LastUpdatedBy": "dborini@vitasjordan.com",
                "LastUpdatedDate": "2018-12-27T09:01:57.897",
                "UserIdentifier": null,
                "ImageUrl": null,
                "ImageData": null,
                "LocationId": 3768,
                "DistributorId": 0,
                "TenantId": 0,
                "EffectiveEndDate": "2099-01-02T04:59:59",
                "EffectiveStartDate": "2018-11-22T05:00:00",
                "AddressId": null,
                "ParentUserId": null,
                "ServerUserID": "9662",
                "ServerBranchID": "12",
                "TmXAddress": null,
                "TmXDevice": null,
                "TmxUserDevice": [],
                "TmxCompanyBranchUsersMapping": [],
                "TmxUserRoleMapping": [],
                "TmxLoanLimit": [],
                "CompanyName": null,
                "DeviceId": 0,
                "PrimaryNationalIdTypeLkpId": null,
                "PrimaryNationalIdentifierValue": null,
                "CompanyBranchIds": null,
                "RoleIds": null,
                "RoleId": 0
            },
            "ObjectState": 0,
            "TmxBusinessLoanSupplierBuyerDetail": [],
            "TmxBusinessMonthlyExpenseDetail": [],
            "TmxBusinessMonthlyIncomeDetail": [],
            "TmxLoanApplicationChecklist": [
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18946,
                    "AttachmentURL": "https://finuat.blob.core.windows.net/images-uat/2019-01/82d9fbde-3076-434b-811d-16392ba1a0e9.pdf",
                    "LoanProductChecklistId": 3,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.557",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:48.897",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 3,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Family Passport",
                        "MappingDocumentType": "24",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18972,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 1,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.033",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.043",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 1,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "National ID Card",
                        "MappingDocumentType": "22",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18973,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 2,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.193",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 2,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Passport",
                        "MappingDocumentType": "23",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18974,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 4,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.34",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 4,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Military Card",
                        "MappingDocumentType": "25",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18975,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 5,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.49",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 5,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Residency Card",
                        "MappingDocumentType": "26",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18976,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 6,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.647",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 6,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Rent Contract",
                        "MappingDocumentType": "27",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18977,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 7,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.797",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 7,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Salary Slip",
                        "MappingDocumentType": "28",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18978,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 8,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:49.947",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 8,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Water or Electricity bill",
                        "MappingDocumentType": "29",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18979,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 9,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.113",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 9,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Employment contract",
                        "MappingDocumentType": "30",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18980,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 10,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.263",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 10,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Account Statements",
                        "MappingDocumentType": "31",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18981,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 11,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.413",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 11,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Drivers License",
                        "MappingDocumentType": "32",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18982,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 12,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.047",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.563",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 12,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Work Permit",
                        "MappingDocumentType": "33",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18983,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 13,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.717",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 13,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Commercial Register",
                        "MappingDocumentType": "34",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18984,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 14,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:50.867",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 14,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Balance Sheet",
                        "MappingDocumentType": "35",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18985,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 15,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:51.043",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 15,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Estimated Car Value",
                        "MappingDocumentType": "36",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18986,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 153,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:51.507",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 153,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Student Proof Document",
                        "MappingDocumentType": null,
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18987,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 154,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:51.66",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 154,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Sharing System Report Summary",
                        "MappingDocumentType": "37",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18988,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 155,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:51.81",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 155,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Legal Records Check",
                        "MappingDocumentType": "38",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18989,
                    "AttachmentURL": "https://finuat.blob.core.windows.net/images-uat/2019-01/a93bb5e9-9800-49db-b8f1-1586bda47edd.pdf",
                    "LoanProductChecklistId": 156,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:51.977",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 156,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Business Visit Report ",
                        "MappingDocumentType": "39",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18990,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 157,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.127",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 157,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Clients Loan Status History",
                        "MappingDocumentType": "40",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                },
                {
                    "Attachment": null,
                    "LoanApplicationChecklistId": 18991,
                    "AttachmentURL": null,
                    "LoanProductChecklistId": 158,
                    "LoanApplicationId": 4009,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T08:43:46.063",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.277",
                    "ImageData": null,
                    "MimeType": null,
                    "DocumentVersion": null,
                    "VerificationRequired": null,
                    "LocationID": null,
                    "AccountApplicationID": null,
                    "UserID": null,
                    "TmxProductChecklist": {
                        "ProductChecklistId": 158,
                        "CreatedBy": "Hafsa",
                        "CreatedDate": "2017-04-20T16:54:51",
                        "LastUpdatedBy": "Hafsa",
                        "LastUpdatedDate": "2017-04-20T16:54:51",
                        "ProductId": 30,
                        "CheckListItemName": "Other Needed Documents",
                        "MappingDocumentType": "41",
                        "TmxAccountApplicationChecklist": null,
                        "TmxProduct": null
                    }
                }
            ],
            "TmxLoanUtilizationDetail": [],
            "TmxCreditScoreValuation": [],
            "TmxLoanApplicationDBRDetail": [
                {
                    "LoanApplicationDBRDetailId": 2420,
                    "LoanApplicationId": 4009,
                    "Occupation": null,
                    "Segment": null,
                    "NetIncomePrimaryBorrower": null,
                    "NetIncomeIncludingCoBorrower": null,
                    "AppliedLimit": null,
                    "EmiOfTakeOverAccounts": null,
                    "SegmentMarkup": null,
                    "UDFData": "{\"EmiOnus\":null,\"AggregateOnusDBR\":null,\"TmxTenant\":null,\"ObjectState\":0,\"NetIncome\":1383,\"RevenuetoTotalExpensesRatio\":4.79,\"InstallmentstoTotalNetIncomeRatio\":0.06,\"DebtBurdenExistingLoansRatio\":0.03,\"DebtBurdenAddingtheNewLoanRatio\":0.08,\"DebtBurdenClientandasaGuarantorRatio\":0.08}",
                    "TenantId": 0,
                    "ActiveFlag": false,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.557",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.573",
                    "AggregateDBR": null,
                    "SecuredAmount": null,
                    "UnSecuredAmount": null,
                    "EmiOnus": null,
                    "AggregateOnusDBR": null,
                    "MaxAllowedDBR": null,
                    "MaxAllowedOnusDBR": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "ObjectState": 0,
                    "NetIncome": 1383,
                    "RevenuetoTotalExpensesRatio": 4.79,
                    "InstallmentstoTotalNetIncomeRatio": 0.06,
                    "DebtBurdenExistingLoansRatio": 0.03,
                    "DebtBurdenAddingtheNewLoanRatio": 0.08,
                    "DebtBurdenClientandasaGuarantorRatio": 0.08
                }
            ],
            "TmxDBREligibility": [],
            "TmxCompanyBranch": {
                "TenantId": 1,
                "CompanyId": 1,
                "CompanyBranchId": 15,
                "BranchCode": "12",
                "BranchName": "Jbeiha",
                "BranchDescription": null,
                "CreatedBy": "dborini@vitasjordan.com",
                "CreatedDate": "2018-11-22T07:44:46.85",
                "LastUpdatedBy": "admin@vitas.com",
                "LastUpdatedDate": "2018-11-27T07:20:00.4",
                "AddressId": 8036,
                "BranchPhoneNumber1": "065337516",
                "BranchPhoneNumber2": null,
                "EffectiveStartDate": "2018-11-22T05:00:00",
                "EffectiveEndDate": "2100-01-02T04:59:59",
                "LocationId": 3767,
                "BranchManagerId": null,
                "TmxAddress": null,
                "TmxCompany": null,
                "TmxLoanApplication": null,
                "TmxCompanyBranchUsersMapping": [],
                "TmxLocation": null
            },
            "TmxWorkflowHistory": [
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "whajahja@vitasjordan.com",
                    "FromActivity": "Draft",
                    "ToActivity": "TL Verification",
                    "TransitionTime": "2019-01-27T07:25:15.38",
                    "Transition": "Direct",
                    "TriggerName": null,
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "whajahja@vitasjordan.com",
                    "FromActivity": "TL Verification",
                    "ToActivity": "Compliance Officer Verification",
                    "TransitionTime": "2019-01-27T07:51:31.09",
                    "Transition": "Direct",
                    "TriggerName": "SendToCO",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "malsoudi@vitasjordan.com",
                    "FromActivity": "Compliance Officer Verification",
                    "ToActivity": "BM Verification",
                    "TransitionTime": "2019-01-27T08:11:08.3",
                    "Transition": "Direct",
                    "TriggerName": "SendToBM",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "rjaber@vitasjordan.com",
                    "FromActivity": "BM Verification",
                    "ToActivity": "Deviation Approval",
                    "TransitionTime": "2019-01-27T08:39:22.287",
                    "Transition": "NotSpecified",
                    "TriggerName": "SetState",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "aalmikhi@vitasjordan.com",
                    "FromActivity": "Deviation Approval",
                    "ToActivity": "BM Verification",
                    "TransitionTime": "2019-01-27T09:08:22.733",
                    "Transition": "NotSpecified",
                    "TriggerName": "SetState",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "rjaber@vitasjordan.com",
                    "FromActivity": "BM Verification",
                    "ToActivity": "Draft",
                    "TransitionTime": "2019-01-27T09:32:09.81",
                    "Transition": "Reverse",
                    "TriggerName": "SendBackToFO",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "rjaber@vitasjordan.com",
                    "FromActivity": "Draft",
                    "ToActivity": "TL Verification",
                    "TransitionTime": "2019-01-27T09:32:09.857",
                    "Transition": "Direct",
                    "TriggerName": "SendBackToFO",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "whajahja@vitasjordan.com",
                    "FromActivity": "TL Verification",
                    "ToActivity": "Compliance Officer Verification",
                    "TransitionTime": "2019-01-27T09:38:15.017",
                    "Transition": "Direct",
                    "TriggerName": "SendToCO",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "malsoudi@vitasjordan.com",
                    "FromActivity": "Compliance Officer Verification",
                    "ToActivity": "BM Verification",
                    "TransitionTime": "2019-01-27T09:41:01.237",
                    "Transition": "Direct",
                    "TriggerName": "SendToBM",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "rjaber@vitasjordan.com",
                    "FromActivity": "BM Verification",
                    "ToActivity": "Credit Officer",
                    "TransitionTime": "2019-01-27T09:51:14.18",
                    "Transition": "Direct",
                    "TriggerName": "SendToNext",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "aalmikhi@vitasjordan.com",
                    "FromActivity": "Credit Officer",
                    "ToActivity": "Deviation Approval",
                    "TransitionTime": "2019-01-27T12:04:16.113",
                    "Transition": "NotSpecified",
                    "TriggerName": "SetState",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "oalfarajat@vitasjordan.com",
                    "FromActivity": "Deviation Approval",
                    "ToActivity": "Credit Officer",
                    "TransitionTime": "2019-01-27T12:18:35.883",
                    "Transition": "NotSpecified",
                    "TriggerName": "SetState",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "aalmikhi@vitasjordan.com",
                    "FromActivity": "Credit Officer",
                    "ToActivity": "Credit Officer Manager",
                    "TransitionTime": "2019-01-27T12:20:38.517",
                    "Transition": "Direct",
                    "TriggerName": "SendToNextLevel",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "oalfarajat@vitasjordan.com",
                    "FromActivity": "Credit Officer Manager",
                    "ToActivity": "MIS Verification",
                    "TransitionTime": "2019-01-27T12:23:41.613",
                    "Transition": "Direct",
                    "TriggerName": "SendToMIS",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "ahussein@vitasjordan.com",
                    "FromActivity": "MIS Verification",
                    "ToActivity": "Loan Approved",
                    "TransitionTime": "2019-02-08T15:59:35.273",
                    "Transition": "Direct",
                    "TriggerName": "Approve",
                    "ObjectState": 0
                },
                {
                    "ProcessInstanceId": "3d3bb9d6-c8d2-41e8-bd1b-f3afad1ed35a",
                    "Actor": "ahussein@vitasjordan.com",
                    "FromActivity": "Loan Approved",
                    "ToActivity": "MIS Verification",
                    "TransitionTime": "2019-02-08T16:09:29.783",
                    "Transition": "NotSpecified",
                    "TriggerName": "SetState",
                    "ObjectState": 0
                }
            ],
            "TmxLoanApplicationDeviationView": [],
            "TmxLoanApplicationNotAssignDeviation": [
                {
                    "Creator": "whajahja@vitasjordan.com ",
                    "RuleName": "WarningGuarantorMaxAgeLimitAtTL",
                    "RuleMessage": "Guarantor age is greater then 65 year",
                    "DeviationAction": "44976",
                    "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
                    "LoanApplicationId": 4009,
                    "ApprovalId": 766,
                    "DeviationId": 766
                },
                {
                    "Creator": "whajahja@vitasjordan.com ",
                    "RuleName": "WarningClientLastLoanPaidInstallmentAtTL",
                    "RuleMessage": "نسبة تجديد القرض اقل من 50 بالمائة",
                    "DeviationAction": "44976",
                    "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
                    "LoanApplicationId": 4009,
                    "ApprovalId": 767,
                    "DeviationId": 767
                },
                {
                    "Creator": "rjaber@vitasjordan.com ",
                    "RuleName": "DevGuarantorMaxAgeLimit",
                    "RuleMessage": "Age of guarantor is greatert then 65",
                    "DeviationAction": "43113",
                    "UserId": "5c7f292e-3d8c-45af-88db-8b5d0ceb9852",
                    "LoanApplicationId": 4009,
                    "ApprovalId": 775,
                    "DeviationId": 775
                },
                {
                    "Creator": "rjaber@vitasjordan.com ",
                    "RuleName": "DevPaidInstallmentPercentage",
                    "RuleMessage": "Last loan is paid less then 50% of installments",
                    "DeviationAction": "43113",
                    "UserId": "5c7f292e-3d8c-45af-88db-8b5d0ceb9852",
                    "LoanApplicationId": 4009,
                    "ApprovalId": 776,
                    "DeviationId": 776
                },
                {
                    "Creator": "aalmikhi@vitasjordan.com",
                    "RuleName": "DevSecondApprovalRequired",
                    "RuleMessage": "Second approval is required",
                    "DeviationAction": "43113",
                    "UserId": "c14daaf7-9da7-4cdf-a80c-1941244abe8f",
                    "LoanApplicationId": 4009,
                    "ApprovalId": 792,
                    "DeviationId": 792
                }
            ],
            "TmxCreditScore": [],
            "TmxOtherOutstandingLoanDetail": [
                {
                    "OtherOutstandingLoanDetailId": 620,
                    "LoanInstituteName": "42677",
                    "TotalLoanAmount": 2300,
                    "LoanUsage": null,
                    "RowNumber": null,
                    "LoanApplicationId": 4009,
                    "LoanOutstandingAmount": 1800,
                    "LoanCompletionDate": "2022-01-27T00:00:00",
                    "FamilyMemberGuarantor": "مجاهد",
                    "GuaranteedName": "نعيم",
                    "RelationshipLkp": 39230,
                    "MFIBankLkp": 39146,
                    "MonthlyInstallmentAmount": 89,
                    "TmxLoanApplication": null
                }
            ],
            "TmxLoanApplicationDetail": [
                {
                    "LoanApplicationDetailID": 1112,
                    "LoanApplicationID": 4009,
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.573",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.727",
                    "UDFData": "{\"ObjectState\":0,\"PreviousJobHiringDate\":\"2003-01-27T05:00:00\",\"PreviousJobResignDate\":\"2009-01-27T05:00:00\",\"SelectedProduct\":\"44977\",\"LoanRequestDate\":\"2019-01-27T05:00:00\",\"LoanSubProductEMI\":\"43032\",\"InsuranceApplied\":\"44980\",\"AreaSqMeter\":155,\"CompensatedByLO\":\"المقترض\",\"LoanCategoryByBmUdf\":\"44990\",\"CompensatedByBM\":\"المقترض\",\"LoanCategoryByCoUdf\":\"44990\",\"CompensatedByCA\":\"العميل\",\"FUND\":\"Vitas Jordan\",\"InsuranceAppliedSummeryUdf\":\"45016\",\"CompensatedBySumm\":\"العميل\",\"LoanCategoryBySummeryUdf\":44990,\"LoanCategoryByCmUdf\":44990}",
                    "TmXLoanApplication": null,
                    "ObjectState": 0,
                    "PreviousJobHiringDate": "2003-01-27T05:00:00",
                    "PreviousJobResignDate": "2009-01-27T05:00:00",
                    "SelectedProduct": "44977",
                    "LoanRequestDate": "2019-01-27T05:00:00",
                    "LoanSubProductEMI": "43032",
                    "InsuranceApplied": "44980",
                    "AreaSqMeter": 155,
                    "CompensatedByLO": "المقترض",
                    "LoanCategoryByBmUdf": "44990",
                    "CompensatedByBM": "المقترض",
                    "LoanCategoryByCoUdf": "44990",
                    "CompensatedByCA": "العميل",
                    "FUND": "Vitas Jordan",
                    "InsuranceAppliedSummeryUdf": "45016",
                    "CompensatedBySumm": "العميل",
                    "LoanCategoryBySummeryUdf": 44990,
                    "LoanCategoryByCmUdf": 44990
                }
            ],
            "Status": null,
            "Error": null,
            "IsNomineeAvailable": null,
            "MWPostedDate": null,
            "MultipleLoanIndicatorLkp": null,
            "LoanUtilizationCheckLkp": null,
            "TakafulAmount": null,
            "TmxAuditTrail": null,
            "TmxLoanApplicationRemark": [
                {
                    "LoanApplicationRemarkId": 3291,
                    "LoanApplicationId": 4009,
                    "ActionType": "Draft",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:51:31.293",
                    "LastUpdatedBy": "whajahja@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T07:51:31.293",
                    "Comments": "شيكات مصدر بديل السداد للعميل",
                    "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3296,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToCO",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "malsoudi@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T08:11:08.533",
                    "LastUpdatedBy": "malsoudi@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T08:11:08.533",
                    "Comments": "تم التأكد من الوثائق",
                    "UserId": "595097ee-e41f-44d0-a3f4-8e8e45d07cd5",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3301,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToBM",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "rjaber@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T08:39:42.513",
                    "LastUpdatedBy": "rjaber@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T08:39:42.513",
                    "Comments": "ارجو الموافقه على الاستثناء",
                    "UserId": "03997d15-f182-45e4-b8e1-f2d84781995e",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3308,
                    "LoanApplicationId": 4009,
                    "ActionType": "DeviationApproval",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T09:08:22.857",
                    "LastUpdatedBy": "aalmikhi@vitasjordan.com",
                    "LastUpdatedDate": "2019-01-27T09:08:22.857",
                    "Comments": "موافق",
                    "UserId": "5c7f292e-3d8c-45af-88db-8b5d0ceb9852",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3315,
                    "LoanApplicationId": 4009,
                    "ActionType": "DeviationApproved",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "rjaber@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T09:32:10.03",
                    "LastUpdatedBy": "rjaber@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T09:32:10.03",
                    "Comments": "فءلب",
                    "UserId": "03997d15-f182-45e4-b8e1-f2d84781995e",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3316,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendBackToFO",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T09:38:15.22",
                    "LastUpdatedBy": "whajahja@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T09:38:15.22",
                    "Comments": "مكرر",
                    "UserId": "b1c46997-0118-4fff-ac7e-77dae2e64fbb",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3318,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToCO",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "malsoudi@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T09:41:01.44",
                    "LastUpdatedBy": "malsoudi@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T09:41:01.44",
                    "Comments": "تم اضافه صور للمشروع",
                    "UserId": "595097ee-e41f-44d0-a3f4-8e8e45d07cd5",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3322,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToBM",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "rjaber@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T09:51:14.823",
                    "LastUpdatedBy": "rjaber@vitasjordan.com ",
                    "LastUpdatedDate": "2019-01-27T09:51:14.823",
                    "Comments": "مكرر",
                    "UserId": "03997d15-f182-45e4-b8e1-f2d84781995e",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3346,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToNext",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T12:04:36.387",
                    "LastUpdatedBy": "aalmikhi@vitasjordan.com",
                    "LastUpdatedDate": "2019-01-27T12:04:36.387",
                    "Comments": "عميل جيد",
                    "UserId": "5c7f292e-3d8c-45af-88db-8b5d0ceb9852",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3347,
                    "LoanApplicationId": 4009,
                    "ActionType": "DeviationApproval",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "oalfarajat@vitasjordan.com",
                    "CreatedDate": "2019-01-27T12:18:36.01",
                    "LastUpdatedBy": "oalfarajat@vitasjordan.com",
                    "LastUpdatedDate": "2019-01-27T12:18:36.01",
                    "Comments": null,
                    "UserId": "c14daaf7-9da7-4cdf-a80c-1941244abe8f",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3349,
                    "LoanApplicationId": 4009,
                    "ActionType": "DeviationApproved",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "aalmikhi@vitasjordan.com",
                    "CreatedDate": "2019-01-27T12:20:38.707",
                    "LastUpdatedBy": "aalmikhi@vitasjordan.com",
                    "LastUpdatedDate": "2019-01-27T12:20:38.707",
                    "Comments": "عميل جيد",
                    "UserId": "5c7f292e-3d8c-45af-88db-8b5d0ceb9852",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3350,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToNextLevel",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "oalfarajat@vitasjordan.com",
                    "CreatedDate": "2019-01-27T12:23:41.847",
                    "LastUpdatedBy": "oalfarajat@vitasjordan.com",
                    "LastUpdatedDate": "2019-01-27T12:23:41.847",
                    "Comments": null,
                    "UserId": "c14daaf7-9da7-4cdf-a80c-1941244abe8f",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                },
                {
                    "LoanApplicationRemarkId": 3499,
                    "LoanApplicationId": 4009,
                    "ActionType": "SendToMIS",
                    "RemarksLkp": 0,
                    "TenantId": 1,
                    "CreatedBy": "ahussein@vitasjordan.com",
                    "CreatedDate": "2019-02-08T10:59:40.557",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:59:40.557",
                    "Comments": "ABC",
                    "UserId": "0559a72c-8eee-4321-8646-c83853d67225",
                    "AccountApplicationID": null,
                    "TmxAccountApplication": null,
                    "TmxLoanApplication": null,
                    "TmxUser": null,
                    "TmxTenant": null
                }
            ],
            "TmxCreditScoreHistory": null,
            "TmxCreditScoreQuestion": null,
            "TmxCurrency": null,
            "TmxInsurance": [],
            "TmxLoanApplicationChecklistHistory": [],
            "TmxLoanApplicationPJP": null,
            "TmxSchoolLoanApplicationDetail": null,
            "TmxLoanApplicationToGuarantorMapping": [
                {
                    "LoanApplicationToGuarantorMapId": 3885,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "ahussein@vitasjordan.com",
                    "CreatedDate": "2019-02-08T10:49:01.787",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:49:01.787",
                    "TenantId": 0,
                    "GuarantorCustomerRelationLkp": null,
                    "ActiveFlag": false,
                    "LoanApplicationId": 4009,
                    "GuarantorId": 3863,
                    "TmxGuarantor": {
                        "GuarantorId": 3863,
                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                        "EffectiveEndDate": "2019-02-08T10:48:46.883",
                        "CreatedBy": "ahussein@vitasjordan.com",
                        "CreatedDate": "2019-02-08T10:49:01.337",
                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                        "LastUpdatedDate": "2019-02-08T10:49:01.337",
                        "TenantId": 0,
                        "GuarantorTypeLkp": 0,
                        "CurrencyId": null,
                        "ActiveFlag": false,
                        "GuarantorNumber": null,
                        "CustomerFamilyMemberId": null,
                        "PersonId": 6294,
                        "GuarantorMFIEmployeeRelationLkp": 8,
                        "GuarantorMFIStaffMemberRelationLkp": null,
                        "DebtBurdenRatio": 0.12,
                        "TotalMonthlyLoanAmount": null,
                        "TotalLoanAmount": 66,
                        "TotalBalanceLoanAmount": null,
                        "TotalIncomeAmount": null,
                        "TotalExpenseAmount": 266,
                        "TotalNetIncome": 294,
                        "DelayInDays": null,
                        "LoanStatus": null,
                        "TmxCurrency": null,
                        "TmxPerson": {
                            "PersonID": 6294,
                            "PersonFirstName": "سعد الدين",
                            "PersonDateOfBirth": "1950-01-27T00:00:00",
                            "PersonGenderLkp": 40545,
                            "CreatedBy": "ahussein@vitasjordan.com",
                            "CreatedDate": "2019-02-08T10:49:01.187",
                            "LastUpdatedBy": "ahussein@vitasjordan.com",
                            "LastUpdatedDate": "2019-02-08T10:49:01.187",
                            "TenantID": 0,
                            "PersonMiddleName": null,
                            "PersonLastName": "نور الدين",
                            "ActiveFlag": false,
                            "EffectiveStartDate": "2019-02-08T10:48:46.883",
                            "EffectiveEndDate": "2019-02-08T10:48:46.883",
                            "PersonMaritalStatusLkp": 41375,
                            "PersonBirthName": null,
                            "PersonCallingName": null,
                            "PersonEducationLkp": 41397,
                            "PersonResidenceLkp": null,
                            "PersonResidenceDuration": null,
                            "PersonReligion": null,
                            "FamilyHeadFlag": null,
                            "PersonTechnicalVocationalTraining": null,
                            "PersonTechnicalVocationalTrainingTypeLkp": null,
                            "PersonDisabilityFlag": null,
                            "PersonDisabilityNature": null,
                            "FamilyEarningMemberFlag": null,
                            "PersonHealthLkp": null,
                            "PersonProfessionTypeLkp": null,
                            "PersonTotalIncomeAmount": null,
                            "PersonTotalExpenseAmount": null,
                            "PersonWeddingDate": null,
                            "PersonCurrentAddress": null,
                            "PersonPermanentAddress": null,
                            "CurrencyID": null,
                            "PersonFamilyIdentifier": null,
                            "FamilyChildrenCount": null,
                            "FamilyDependentCount": null,
                            "FamilyMembersCount": 5,
                            "FamilyMigrantsCount": null,
                            "FamilyEarningMembersCount": null,
                            "PersonNationalityLkp": 41378,
                            "PlaceOfBirthLkp": null,
                            "PersonHobbies": null,
                            "PersonLanguagePreferenceLkp": null,
                            "UDFData": "{\"ObjectState\":0,\"PersonAge\":\"69\",\"PersonSpouseName\":\"نورسين\",\"PersonFatherName\":\"احمد\",\"PersonGrandFatherName\":\"محمد\",\"PersonMotherName\":\"سميره\",\"RelationshiptoClient\":39226,\"DateOfHiringInPreviousJob\":\"2009-01-27\",\"DateOfResignFromPreviousJob\":\"2013-01-27\"}",
                            "TmxCurrency": null,
                            "TmxCustomerDetail": null,
                            "TmxPersonProfessionDetail": [
                                {
                                    "PersonProfessionDetailId": 6515,
                                    "ProfessionTypeLkp": 41534,
                                    "OthersProfessionType": "طالب",
                                    "TitlePosition": "عسكري",
                                    "EmployedSince": "2014-01-27                                        ",
                                    "YearsofEngagement": 5,
                                    "NameOfEmployer": null,
                                    "SalaryPerAnum": null,
                                    "NameOfBusiness": null,
                                    "NatureOfBusiness": null,
                                    "DateOfIncorporation": null,
                                    "InvestmentInBusiness": null,
                                    "BusinessTurnOver": null,
                                    "StatusOfOwnership": null,
                                    "SalaryIncome": null,
                                    "SbpIndustryParentLkp": null,
                                    "SbpIndustryLkp": null,
                                    "StatusLkp": 41568,
                                    "CountryOfIncorporation": null,
                                    "ProfessionalDegreeForSEP": null,
                                    "DepartmentName": null,
                                    "EstablishedSince": null,
                                    "PreviousEmployerName": null,
                                    "PreviousEmployerYearsOfEngagement": 4,
                                    "OverallLengthOfService": null,
                                    "AddressId": null,
                                    "SegmentLkp": null,
                                    "OfficeTelephoneNumber1": null,
                                    "OfficeTelephoneExtension": null,
                                    "OfficeAddress": "عمان_المدينه الرياضيه",
                                    "PersonId": 6294,
                                    "ActiveFlag": false,
                                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                    "CreatedBy": "ahussein@vitasjordan.com",
                                    "CreatedDate": "2019-02-08T10:49:02.087",
                                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                                    "LastUpdatedDate": "2019-02-08T10:49:02.087",
                                    "TenantId": 0,
                                    "TmxAddress": null,
                                    "TmxTenant": null
                                }
                            ],
                            "TmxPersonToAddressMapping": [
                                {
                                    "TenantId": 0,
                                    "PersonToAddressMapId": 4639,
                                    "CreatedBy": "ahussein@vitasjordan.com",
                                    "CreatedDate": "2019-02-08T10:49:02.25",
                                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                                    "LastUpdatedDate": "2019-02-08T10:49:02.25",
                                    "AddressTypeLkp": 1,
                                    "AddressId": 11910,
                                    "PersonId": 6294,
                                    "ActiveFlag": false,
                                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                    "PrimaryAddressFlag": false,
                                    "TmxAddress": {
                                        "AddressID": 11910,
                                        "LastUpdatedBy": "ahussein@vitasjordan.com",
                                        "AddressLine4": null,
                                        "CreatedDate": "2019-02-08T10:49:00.733",
                                        "Latitude": null,
                                        "LastUpdatedDate": "2019-02-08T10:49:00.733",
                                        "AddressGeographyId": null,
                                        "TenantId": 0,
                                        "AddressLine2": "42640",
                                        "CreatedBy": "ahussein@vitasjordan.com",
                                        "PostalZipCode": null,
                                        "AddressLine1": "عمان_طبربور_قرب أسواق جنه الارض",
                                        "Longitude": null,
                                        "AddressLine3": "42094",
                                        "Country": null,
                                        "Province": null,
                                        "NearestLandmark": null,
                                        "City": null,
                                        "AccomodationTypeLkp": null,
                                        "AreaCode": null,
                                        "TmxAddressGeography": null,
                                        "TmxUser": null,
                                        "UDFData": "{}",
                                        "ActiveFlag": false,
                                        "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                        "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                        "AddressCoordinates": null,
                                        "AddressTypeLkpId": null
                                    },
                                    "TmxPerson": null,
                                    "TmxPersonAddressContact": [
                                        {
                                            "TenantId": 0,
                                            "PersonAddressContactId": 4240,
                                            "CreatedBy": "ahussein@vitasjordan.com",
                                            "CreatedDate": "2019-02-08T10:49:02.4",
                                            "LastUpdatedBy": "ahussein@vitasjordan.com",
                                            "LastUpdatedDate": "2019-02-08T10:49:02.4",
                                            "ContactTypeLkp": 0,
                                            "ActiveFlag": false,
                                            "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                            "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                            "ContactNumber": "0777411112",
                                            "ContactExtension": null,
                                            "PrimaryContactFlag": false,
                                            "ContactEmailAddress": null,
                                            "PersonToAddressMapId": 4639,
                                            "TmxPersonToAddressMapping": null,
                                            "TmxTenant": null
                                        }
                                    ],
                                    "TmxTenant": null
                                }
                            ],
                            "TmxPersonNationalIdentifier": [
                                {
                                    "TenantId": 0,
                                    "PersonNationalIdentifierId": 13128,
                                    "NationalIdTypeLkp": 5,
                                    "NationalIdentifierValue": "9874512239",
                                    "NationalIdIssueDate": null,
                                    "NationalIdExpiryDate": "2020-01-27T00:00:00",
                                    "CreatedBy": "ahussein@vitasjordan.com",
                                    "CreatedDate": "2019-02-08T10:49:01.937",
                                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                                    "LastUpdatedDate": "2019-02-08T10:49:01.937",
                                    "PersonId": 6294,
                                    "ActiveFlag": false,
                                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                    "DocumentType": null,
                                    "TmxTenant": null
                                }
                            ],
                            "TmxPersonIncomeDetail": [],
                            "TmxPersonExpenseDetail": [],
                            "TmxTenant": null,
                            "ObjectState": 0,
                            "PersonAge": "69",
                            "PersonSpouseName": "نورسين",
                            "PersonFatherName": "احمد",
                            "PersonGrandFatherName": "محمد",
                            "PersonMotherName": "سميره",
                            "RelationshiptoClient": 39226,
                            "DateOfHiringInPreviousJob": "2009-01-27",
                            "DateOfResignFromPreviousJob": "2013-01-27"
                        },
                        "TmxCustomerFamilyMember": null,
                        "TmxTenant": null,
                        "TmxLoanApplicationToGuarantorMapping": null,
                        "TmxGuarantorLoanDetail": [
                            {
                                "GuarantorLoanDetailId": 3040,
                                "EffectiveStartDate": "2019-02-08T10:48:46.883",
                                "EffectiveEndDate": "2019-02-08T10:48:46.883",
                                "CreatedBy": "ahussein@vitasjordan.com",
                                "CreatedDate": "2019-02-08T10:49:01.637",
                                "LastUpdatedBy": "ahussein@vitasjordan.com",
                                "LastUpdatedDate": "2019-02-08T10:49:01.637",
                                "TenantId": 0,
                                "CurrencyId": null,
                                "ActiveFlag": null,
                                "GuarantorId": 3863,
                                "TotalLoanAmount": null,
                                "BalanceLoanAmount": 1200,
                                "LendingCompanyName": "فينكا",
                                "MonthlyLoanAmount": 66,
                                "LastPaymentDate": null,
                                "DetailsOfLoans": "جاري",
                                "TmxCurrency": null,
                                "TmxGuarantor": null,
                                "TmxTenant": null,
                                "ObjectState": 0
                            }
                        ],
                        "TmxGuarantorGuaranteeDetail": [
                            {
                                "GuarantorGuranteeDetailId": 2571,
                                "EffectiveStartDate": "0001-01-01T00:00:00",
                                "EffectiveEndDate": "0001-01-01T00:00:00",
                                "CreatedBy": "ahussein@vitasjordan.com",
                                "CreatedDate": "2019-02-08T10:49:01.487",
                                "LastUpdatedBy": "ahussein@vitasjordan.com",
                                "LastUpdatedDate": "2019-02-08T10:49:01.487",
                                "TenantId": 0,
                                "ActiveFlag": false,
                                "GuarantorId": 3863,
                                "GuaranteeInstitutionName": "39145",
                                "GuranteePersonName": "محمد",
                                "GuarantorGuranteeRelationLkp": 39217,
                                "TmxGuarantor": null,
                                "TmxTenant": null,
                                "ObjectState": 0,
                                "BankName": "41284",
                                "FamilyGuaranteePersonName": "سعد الدين",
                                "LastPaymentDate": "2023-01-27",
                                "LoanAmount": 2000,
                                "BalanceLoanAmount": 1000,
                                "MonthlyLoanAmount": 45
                            }
                        ],
                        "TmxGuarantorBankDetail": [],
                        "ObjectState": 0,
                        "SalaryIncome": 400,
                        "TotalIncome": 560,
                        "PersonalExpensesAmount": 200,
                        "GuarantorDebtBurdenRatio": 0.2,
                        "BankChecks": "8",
                        "TransferOfSalary": "8",
                        "PersonalGuarantee": "8",
                        "CarMortgage": "8",
                        "PostedCheque": "8",
                        "MandatoryActivation": "8",
                        "ProxyLetter": "8",
                        "SignatoryGuarantieLetter": "8",
                        "CivilRegistrationNumber": "768/355",
                        "IDDocumentType": "41721",
                        "IDDocumentNumber": "hgj668",
                        "GuarantorMFIRelationToStaff": "ابن اخ",
                        "GuarantorGuaranteeTotalMonthlyPayment": "45",
                        "OtherIncome": "160",
                        "IdExpiryDate": "2020-01-27"
                    },
                    "TmxLoanApplication": null,
                    "TmxTenant": null
                }
            ],
            "TmxLoanApplicationToCollateralMapping": null,
            "TmxLoanApplicationRecommendation": [
                {
                    "LoanApplicationRecommendationId": 6008,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.56",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": "45156",
                    "RecommendedLoanAmount": 1500,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "24",
                    "CreditRationale": "توقيع العميل و الكفيل عقد و كمبياله",
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": null,
                    "InsuranceTimeSpan": null,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": 8,
                    "RoleLkp": 1,
                    "Comment": null,
                    "DecisionLkp": 45089,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": null,
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                },
                {
                    "LoanApplicationRecommendationId": 6009,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.71",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": null,
                    "RecommendedLoanAmount": 0,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "0",
                    "CreditRationale": null,
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": null,
                    "InsuranceTimeSpan": null,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": null,
                    "RoleLkp": 2,
                    "Comment": null,
                    "DecisionLkp": null,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": null,
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                },
                {
                    "LoanApplicationRecommendationId": 6010,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:54.86",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": null,
                    "RecommendedLoanAmount": 2500,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "36",
                    "CreditRationale": "موافق حسب توصية مسؤول علاقات مع رفع المبلغ",
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": "العميل",
                    "InsuranceTimeSpan": null,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": 8,
                    "RoleLkp": 3,
                    "Comment": null,
                    "DecisionLkp": 41715,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": "43032",
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                },
                {
                    "LoanApplicationRecommendationId": 6011,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:55.01",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": null,
                    "RecommendedLoanAmount": 2500,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "36",
                    "CreditRationale": "العميل جيد",
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": "العميل",
                    "InsuranceTimeSpan": null,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": 8,
                    "RoleLkp": 4,
                    "Comment": null,
                    "DecisionLkp": 41715,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": "43032",
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                },
                {
                    "LoanApplicationRecommendationId": 6012,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:55.16",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": null,
                    "RecommendedLoanAmount": 2500,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "33",
                    "CreditRationale": "العميل جيد",
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": "العميل",
                    "InsuranceTimeSpan": null,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": 9,
                    "RoleLkp": 5,
                    "Comment": null,
                    "DecisionLkp": 41715,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": "43032",
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                },
                {
                    "LoanApplicationRecommendationId": 6013,
                    "EffectiveStartDate": "0001-01-01T00:00:00",
                    "EffectiveEndDate": "0001-01-01T00:00:00",
                    "CreatedBy": "whajahja@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T07:49:25.587",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:55.313",
                    "TenantId": 0,
                    "CurrencyId": 1,
                    "ActiveFlag": false,
                    "CriminalRecord": null,
                    "RecommendedLoanAmount": 2500,
                    "LoanApplicationId": 4009,
                    "RecommendedLoanTerms": "33",
                    "CreditRationale": null,
                    "ReceommendingUserId": null,
                    "InsuranceBeneficiary": "العميل",
                    "InsuranceTimeSpan": 33,
                    "InsuranceTimeSpanLkp": null,
                    "CompensatedLoansCount": 9,
                    "RoleLkp": 6,
                    "Comment": null,
                    "DecisionLkp": 41715,
                    "DecisionDate": "2019-01-27T00:00:00",
                    "SubProduct": "43032",
                    "InsuranceApplied": null,
                    "TmxCurrency": null,
                    "TmxLoanApplication": null,
                    "TmxTenant": null,
                    "TmxUser": null
                }
            ],
            "TmxLoanApplicationComplianceVerification": [
                {
                    "LoanApplicationComplianceVerificationId": 638,
                    "EffectiveStartDate": "2019-02-08T10:48:46.883",
                    "EffectiveEndDate": "2019-02-08T10:48:46.883",
                    "CreatedBy": "malsoudi@vitasjordan.com ",
                    "CreatedDate": "2019-01-27T08:08:34.57",
                    "LastUpdatedBy": "ahussein@vitasjordan.com",
                    "LastUpdatedDate": "2019-02-08T10:48:52.427",
                    "TenantId": 0,
                    "ActiveFlag": false,
                    "LoanPurposeVerificationResult": "44353",
                    "LoanApplicationId": 4009,
                    "LoanPurposeVerification": null,
                    "LoanPurpose": "دفع اجور ممرض",
                    "VerificationMechanism": "45104",
                    "LoanTypeLkp": null
                }
            ],
            "TmxTenant": null,
            "TmxAccountApplication": null,
            "Commands": [
                {
                    "HiddenValue": "Approve",
                    "VisibleValue": "Approve",
                    "ParameterName": null,
                    "Classifier": 1
                },
                {
                    "HiddenValue": "Cancel",
                    "VisibleValue": "Cancel",
                    "ParameterName": null,
                    "Classifier": 1
                },
                {
                    "HiddenValue": "Reject",
                    "VisibleValue": "Reject",
                    "ParameterName": null,
                    "Classifier": 1
                },
                {
                    "HiddenValue": "SendBackToBM",
                    "VisibleValue": "SendBackToBM",
                    "ParameterName": null,
                    "Classifier": 2
                },
                {
                    "HiddenValue": "SendBackToCA",
                    "VisibleValue": "SendBackToCA",
                    "ParameterName": null,
                    "Classifier": 2
                },
                {
                    "HiddenValue": "SendBackToCAM",
                    "VisibleValue": "SendBackToCAM",
                    "ParameterName": null,
                    "Classifier": 2
                },
                {
                    "HiddenValue": "SendBackToCO",
                    "VisibleValue": "SendBackToCO",
                    "ParameterName": null,
                    "Classifier": 2
                }
            ]
        }
    }
}